// [EVENT-MODE] Simplified navigation — no subscription gating, no locked items

const INVENTOR_NAV = [
  { key: 'dashboard', label: 'Dashboard', icon: '\u2302' },
  { key: 'events', label: 'Events', icon: '\uD83C\uDFAA' },
  { key: 'vault', label: 'Idea Vault', icon: '\uD83D\uDCA1' },
  { key: 'matching', label: 'Company Matching', icon: '\uD83C\uDFAF' },
  { key: 'trends', label: 'Current Trends', icon: '\uD83D\uDCC8' },
  { key: 'bom', label: 'BOM Builder', icon: '\uD83E\uDDEE' },
  { key: 'pitch', label: 'Pitch Builder', icon: '\u2728' },
  { key: 'notes', label: 'Meeting Notes', icon: '\uD83D\uDCDD' },
  { key: 'settings', label: 'Settings', icon: '\u2699' },
];

const COMPANY_NAV = [
  { key: 'dashboard', label: 'Dashboard', icon: '\u2302' },
  { key: 'events', label: 'Events', icon: '\uD83C\uDFAA' },
  { key: 'wishlist', label: 'Wish List', icon: '\uD83D\uDCCB' },
  { key: 'my-inventors', label: 'My Inventors', icon: '\uD83D\uDC65' },
  { key: 'idea-pipeline', label: 'Idea Pipeline', icon: '\uD83D\uDCE5' },
  { key: 'ir-pipeline', label: 'IR Pipeline', icon: '\uD83D\uDCCB' },
  { key: 'market-intelligence', label: 'Market Intelligence', icon: '\uD83E\uDDE0' },
  { key: 'trends', label: 'Current Trends', icon: '\uD83D\uDCC8' },
  { key: 'company-settings', label: 'Company Profile', icon: '\uD83C\uDFE2' },
  { key: 'team', label: 'Team', icon: '\uD83D\uDC65' },
  { key: 'settings', label: 'Account', icon: '\u2699' },
];

const ADMIN_NAV = [
  { key: 'dashboard', label: 'Dashboard', icon: '⌂' },
  { key: 'admin-dashboard', label: 'Admin Panel', icon: '🛡' },
  { key: 'demo-insights', label: 'Demo Insights', icon: '✨' },
  { section: 'Inventor View', hint: 'What inventors see and use' },
  { key: 'vault', label: 'Idea Vault', icon: '\uD83D\uDCA1' },
  { key: 'matching', label: 'Company Matching', icon: '\uD83C\uDFAF' },
  { key: 'bom', label: 'BOM Builder', icon: '\uD83E\uDDEE' },
  { key: 'pitch', label: 'Pitch Builder', icon: '\u2728' },
  { section: 'Company View', hint: 'What companies see and use' },
  { key: 'wishlist', label: 'Wish List', icon: '\uD83D\uDCCB' },
  { key: 'my-inventors', label: 'My Inventors', icon: '\uD83D\uDC65' },
  { key: 'companies', label: 'Companies', icon: '\uD83C\uDFE2' },
  { key: 'idea-pipeline', label: 'Idea Pipeline', icon: '\uD83D\uDCE5' },
  { key: 'ir-pipeline', label: 'IR Pipeline', icon: '\uD83D\uDCCB' },
  { key: 'market-intelligence', label: 'Market Intelligence', icon: '\uD83E\uDDE0' },
  { section: 'Organizer View', hint: 'Event management tools' },
  { key: 'events', label: 'Events', icon: '\uD83C\uDFAA' },
  { section: 'Platform', hint: 'Shared across all roles' },
  { key: 'trends', label: 'Current Trends', icon: '\uD83D\uDCC8' },
  { key: 'settings', label: 'Settings', icon: '\u2699' },
];

export function getNavItems(role, hasSubscription, hasEventAccess, subscriptionTier, badges = {}) {
  let items;
  if (role === 'admin') {
    items = ADMIN_NAV;
  } else if (role === 'pending_company') {
    return [];
  } else if (role === 'company') {
    items = COMPANY_NAV;
  } else {
    // inventor, studio, or default
    items = INVENTOR_NAV;
  }

  return items.map(item => {
    if (item.key && badges[item.key] !== undefined) {
      return { ...item, badge: badges[item.key] };
    }
    return item;
  });
}
